import {useFormContext} from '@yandex-delivery/nlf-form/v2'
import React, {memo} from 'react'

import {useConfigContext} from '../../contexts'
import {FormMapUI} from './FormMapUI/FormMapUI'
import {useFormMap} from './hooks'
import type {Props} from './types'

export const OrderMap = memo<Props>(function OrderMap({dir, lang = 'ru_RU'}) {
  const {initialProps} = useConfigContext()
  const {location} = useConfigContext()
  const {watch} = useFormContext()
  const sourcePoint = watch('route.source.address.coordinates')

  const {
    isDragPointAllowed,
    isRouteVisible,
    fetchTaxiSuggestHandler,
    orderPointsCoordinates,
    mapLocationResult,
    routePointCoordinates,
    sourcePointCoordinates,
  } = useFormMap({location: sourcePoint || initialProps?.zonePoint || location})

  return (
    <FormMapUI
      dir={dir}
      isDragPointAllowed={isDragPointAllowed}
      isRouteVisible={isRouteVisible}
      lang={lang}
      location={location}
      mapLocationResult={mapLocationResult}
      onPlacemarkChange={fetchTaxiSuggestHandler}
      orderPointsCoordinates={orderPointsCoordinates}
      routePointCoordinates={routePointCoordinates}
      sourcePointCoordinates={sourcePointCoordinates}
    />
  )
})
